import { connect } from "react-redux";
import Zubehoer from "./Zubehoer";

import { genChangeCompressorPath } from "../model/Kompressor";
import { defaultAccessoryPath,
	prevInstalledAccessoryIndex,
	nextInstalledAccessoryIndex } from "../model/Zubehoer";

export default connect(state => ({
	location_path: state.router.location.pathname,
	default_path: defaultAccessoryPath(state, "/overview/accessories/"),
	previous_index: prevInstalledAccessoryIndex(state, state.router.location.pathname),
	next_index: nextInstalledAccessoryIndex(state, state.router.location.pathname)
}), dispatch => ({
	gotoCompressor: genChangeCompressorPath(dispatch)
}))(Zubehoer);
